import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import CookieConsent from "./components/CookieConsent";
import Home from "./pages/Home";
import AIServices from "./pages/AIServices";
import BotConsulting from "./pages/BotConsulting";
import OffshorePods from "./pages/OffshorePods";
import CloudManaged from "./pages/CloudManaged";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import CaseStudies from "./pages/CaseStudies";
import Partnerships from "./pages/Partnerships";
import InfrastructureSolutions from "./pages/InfrastructureSolutions";
import DevOpsSolutions from "./pages/DevOpsSolutions";
import CloudOpsSolutions from "./pages/CloudOpsSolutions";
import SecuritySolutions from "./pages/SecuritySolutions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import FAQ from "./pages/FAQ";
import GCCCalculator from "./pages/GCCCalculator";
import Blog from "./pages/Blog";
import Delivery from "./pages/Delivery";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ai-services" element={<AIServices />} />
          <Route path="/services/bot-consulting" element={<BotConsulting />} />
          <Route path="/services/offshore-pods" element={<OffshorePods />} />
          <Route path="/services/cloud-managed" element={<CloudManaged />} />
          <Route path="/services/infrastructure" element={<InfrastructureSolutions />} />
          <Route path="/services/devops" element={<DevOpsSolutions />} />
          <Route path="/services/cloudops" element={<CloudOpsSolutions />} />
          <Route path="/services/security" element={<SecuritySolutions />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/partnerships" element={<Partnerships />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/gcc-cost-calculator" element={<GCCCalculator />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/delivery" element={<Delivery />} />
          </Routes>
          <Footer />
          <CookieConsent />
          <Toaster />
        </BrowserRouter>
      </div>
  );
}

export default App;
